export class Editore {
  _id: string;
  codice: string;
  descrizione: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Editore.ts